export default __webpack_public_path__ + "static/media/p11.f1b7c22c.jpg";